/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';

/** Components */
import Keypad from './Keypad';
import KeypadButton from './KeypadButton';

class CursorControls extends Component {
  render() {
    return (
      <Keypad
        className="cursor-controls"
        onKeyPressWrite={this.props.onKeyPressWrite}
      >
        <KeypadButton
          label={<i className="icon-arrow-dropleft" />}
          value="Left"
        />
        <KeypadButton
          label={<i className="icon-arrow-dropright" />}
          value="Right"
        />
        <KeypadButton
          label={<i className="icon-backspace-outline" />}
          value="Backspace"
        />
      </Keypad>
    );
  }
}

export default CursorControls;
